import { SET_FILTER, SET_CURRENT_STYLE } from './Types';
import {
  ILayerSetting,
  ILayerSettingAction,
  ILayerSettingReducerState
} from './layerSettingsTypes';

const defaultState: any[] = [];

/*
 * filter should look like:
 * {
 *   uid: string (to ref with an active layer, not necessarily the id of an actual layer)
 *   filters: filter object
 *   currentStyleIdx: 0
 * }
 */

/*
Example
{
    "uid": "hmlr_land_parcels",
    // layer uid is key - should match an active layer
    // criteria should be value - matching standard criteria format
    "filters": {
        "id": "root",
        "not": false,
        "type": "group",
        "children": [{
            "id": "427bf9a5-561a-42ab-87d7-dd41599108ca",
            "type": "rule",
            "field": "categories_aggregate",
            "properties": {
                "values": ["Company"], // Probably should make this into indexes, otherwise needs to test value is valid in backend
                "operator": "=="
            }
        }],
        "conjunction": "and"
    },
    "currentStyleIdx": 0
}
*/

function setFilters(state: ILayerSettingReducerState, action: ILayerSettingAction) {
  const newState = [...state];
  const idx = state.findIndex(setting => setting.uid === action.uid);
  if (idx === -1) {
    newState.push({
      uid: action.uid,
      filters: action.filters
    });
  } else {
    const setting = newState[idx];
    newState.splice(idx, 1, {
      ...setting,
      filters: action.filters
    });
  }
  return newState;
}

function setCurrentStyle(
  state: ILayerSettingReducerState,
  action: ILayerSettingAction
) {
  const newState = [...state];
  const idx = state.findIndex(setting => setting.uid === action.uid);
  if (idx === -1) {
    newState.push({
      uid: action.uid,
      currentStyleIdx: action.styleIdx
    } as ILayerSetting);
  } else {
    const setting = newState[idx];
    newState.splice(idx, 1, {
      ...setting,
      currentStyleIdx: action.styleIdx
    });
  }
  return newState;
}

export default function reducer(
  state: ILayerSettingReducerState = defaultState,
  action: ILayerSettingAction
) {
  switch (action.type) {
    case SET_FILTER:
      return setFilters(state, action);
    case SET_CURRENT_STYLE:
      return setCurrentStyle(state, action);
    default:
      return state;
  }
}
